"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var react_tracking_1 = require("react-tracking");
var bind_1 = require("../bind");
var filter_link_1 = require("./filter_link");
var sort_select_1 = require("./sort_select");
var sidebar_toggle_1 = require("./sidebar_toggle");
var SearchControls = /** @class */ (function (_super) {
    tslib_1.__extends(SearchControls, _super);
    function SearchControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchControls.prototype.handleClick = function (evt) {
        this.props.tracking.trackEvent({
            entityId: evt.target.dataset.condition,
            url: evt.target.href
        });
    };
    SearchControls.prototype.render = function () {
        return (React.createElement("div", { className: "grid-filter" },
            this.props.sort && (React.createElement("div", { className: "grid-filter__conditions" },
                React.createElement(filter_link_1.default, { className: "grid-filter__action", rel: "nofollow", "data-condition": "used", activeClassName: "grid-filter__action--active", params: { condition: 'used' }, onClick: this.handleClick }, I18n.t('commons.searchControls.used')),
                React.createElement(filter_link_1.default, { className: "grid-filter__action", rel: "nofollow", "data-condition": "new", activeClassName: "grid-filter__action--active", params: { condition: 'new' }, onClick: this.handleClick }, I18n.t('commons.searchControls.new')))),
            React.createElement("div", { className: "grid-filter__mobile-toggle" },
                React.createElement(sidebar_toggle_1.default, { open: true })),
            this.props.sort && (React.createElement("div", { className: "grid-filter__sort" },
                React.createElement(sort_select_1.default, { sort: this.props.sort })))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], SearchControls.prototype, "handleClick", null);
    SearchControls = tslib_1.__decorate([
        react_tracking_1.default({ componentName: 'SearchControls' })
    ], SearchControls);
    return SearchControls;
}(React.Component));
exports.default = SearchControls;
//# sourceMappingURL=search_controls.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/search_controls.js
// module id = /e2D
// module chunks = 0 1 2 3 9 10 14 20